import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FlashMessagesService} from "angular2-flash-messages";
import {AuthenticationService} from "../../_service/authentication.service";
import {HttpService} from "../../_service/http.service";
import {OrganizationService} from "../../_service/organization.service";
import {WelcomeMainComponent} from "../welcome-part.component";
import {isNullOrUndefined} from "util";
import {LoaderService} from "../../_service/loader.service";
import {OrgLinks} from "../../shared-module/models/org-links";

@Component({
  moduleId: module.id,
  templateUrl: 'login.component.html',
  providers: [AuthenticationService]
})
export class LoginComponent implements OnInit {
  model: any = {
    numberPrefix: '+7'
  };
  public orgLinks: OrgLinks;
  public loading = false;
  isOldUser = false;
  isLoggedIn = false;
  isNeedPasswordReset = false;
  returnUrl: string;
  isOrgHasSmsConfirmation = false;
  userLogin: string;
  password: string;


  constructor(private route: ActivatedRoute,
              public welcomeMainComponent: WelcomeMainComponent,
              private router: Router,
              private authenticationService: AuthenticationService,
              private orgService: OrganizationService,
              private httpService: HttpService,
              private flashMessagesService: FlashMessagesService) {
  }

  ngOnInit() {
    this.authenticationService.logout();
    this.orgService.isHasSmsConfirmation(localStorage.getItem("organizationAlias"))
      .then((isHasSmsConfirmation) => {
        this.isOrgHasSmsConfirmation = isHasSmsConfirmation;
      });
    this.orgLinks = OrganizationService.getOrgLinks();
    console.log("Org links are", this.orgLinks);
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }


  handlePassword(event) {
    this.model.password = event;
    this.password = event;
  }

  login() {
    this.welcomeMainComponent.onMainMessage = "";

    this.authenticationService.login(this.model.username, this.model.password)
    // this.authenticationService.login(this.userLogin, this.password)
      .then(
        data => {
          console.log("Data in login after auth:", data);
          this.isLoggedIn = true;
          this.isOldUser = data.oldUser;

          if (!this.isOldUser) {
            if (this.checkRole(data.roles, "ROLE_ADMIN")) {
              this.router.navigate(["../admin"], {relativeTo: this.route});
            } else if (this.checkRole(data.roles, "ROLE_API")) {
              this.router.navigate(["../integrations"], {relativeTo: this.route});
            } else if (this.checkRole(data.roles, "ROLE_SUPER_ADMIN")) {
              this.router.navigate(["../integrations"], {relativeTo: this.route});
            } else if (this.checkRole(data.roles, "ROLE_USER")) {
              this.router.navigate(["../home"], {relativeTo: this.route});
            } else {
              this.flashMessagesService.show("У данного пользователя не выставленны права. Обратитесь к администратору.", {
                cssClass: 'alert alert-danger danger-font small',
                timeout: 5000
              });
              console.log('No role');
            }
          }
          this.isNeedPasswordReset = false;
        },
        error => {
          console.log(error);
          // TODO: возвращать человеческие ошибки из контроллера
          this.isNeedPasswordReset = true;
          this.isLoggedIn = false;

          this.flashMessagesService.show(JSON.parse(error._body).errorMessage, {
            cssClass: 'alert alert-danger danger-font small',
            timeout: 5000
          });
        });
  }

  enablePasswordReset(event: boolean) {
    this.isNeedPasswordReset = event;
  }

  async handleCodeCheck(event) {
    console.log("handleCodeCheck in login comp. event result: ", event);

    if (event.isCodeCorrect || !this.isOrgHasSmsConfirmation) {
      const result = {
        phone: this.model.numberPrefix + event.phone,
        password: this.model.password,
        login: this.model.username
      };

      this.httpService.postData('rest/' + localStorage.getItem('organizationAlias')
        + '/registerOldUser', JSON.stringify(result))
        .then((data1) => {
          console.log("Registrate v014 user in login result:", data1);
          // this.flashMessagesService.show("Вы успешно подтвердили телефон. Теперь используйте " +
          //   "номер телефона в качестве логина.",
          //   {cssClass: 'alert alert-success small', timeout: 5000});
          this.welcomeMainComponent.onMainMessage = 'Вы успешно зарегистрировались. Для перехода на сайт авторизируйтесь в форме ниже, ' +
            'используя подтверждённый номер телефона и пароль от старого кабинета.';

          this.refreshLoginPage();

        }, (error) => {
          this.flashMessagesService.show(JSON.parse(error._body).errorTitle,
            {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
          console.warn("Registrate v014 user in login ERROR:", error);
          this.refreshLoginPage();
        });
    }
  }

  refreshLoginPage() {

    const currentUrl = this.router.url;
    const refreshUrl = currentUrl.indexOf('login') > -1 ? "/"
      + localStorage.getItem('organizationAlias') + '/registration' : 'login';

    this.router.navigateByUrl(refreshUrl).then(() => this.router.navigateByUrl(currentUrl));
  }

  private checkRole(userRoles: any[], role: any): boolean {
    return !isNullOrUndefined(
      userRoles.find((value, index, obj) => {
        return value === role;
      })
    );
  }

  goToUkPage() {
    window.open(this.orgLinks.ukLink, "_blank");
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/login/login.component.ts